import React from 'react';
import _ from 'lodash';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import request from 'superagent';
import config from '../../../../../config';


class BatchCoachAssign extends React.Component {
    state = {
        selected_user: null,
        coaches_season: [],
        teams: [],
        search_coach: null,
        search_all_teams: null,
        mode: 1
    }
    componentWillReceiveProps = nextProps => {
        const { coaches_season, teams } = nextProps;
        this.setState({ coaches_season, teams });
    }

    toggleTeamAdding = ({ IdTeamDivision }) => {
        const { teams } = this.state;
        let team = _.find(teams, t => t.IdTeamDivision === IdTeamDivision);
        team.adding = !team.adding;
        team.spin = false;
        this.setState({ teams });
    }
    toggleTeamRemoving = ({ IdTeamDivision }) => {
        const { coaches_season = [] } = this.state, { selected_user } = this.state;
        _.chain(coaches_season).each(cs => { cs.removing = (cs.IdTeamDivision === IdTeamDivision && cs.IdUser === selected_user.IdUser) ? true : false; }).value();
        this.setState({ coaches_season });
    }
    assignNewTeam = (newTeam, role) => {
        const { selected_user } = this.state;
        const { teams } = this.state;
        _.find(teams, t => t.IdTeamDivision === newTeam.IdTeamDivision).spin =
            !_.find(teams, t => t.IdTeamDivision === newTeam.IdTeamDivision).spin;

        this.setState({ teams }, () => {
            request.post(`${config.apiEndpoint}/api/v4/roster/force/add`)
                .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
                .send({
                    IdUser: selected_user.IdUser,
                    IdRoleOverride: role.IdRoleOverride,
                    IdTeamDivision: newTeam.IdTeamDivision
                })
                .then(ok => {
                    this.props.seasonActions && this.props.seasonActions.fetchAllCoaches(this.props.params.idSeason);
                    this.toggleTeamAdding(newTeam);
                    this.props.refresh && this.props.refresh();
                });
        });
    }
    doRemoveFromTeam = ({ IdTeamDivision }) => {
        const { selected_user, coaches_season } = this.state;
        let role_index = _.findIndex(coaches_season, cs => cs.IdTeamDivision === IdTeamDivision && cs.IdUser === selected_user.IdUser);
        // TODO: call api idUser/:idTeamDivision/:idRoleOverride
        request.delete(`${config.apiEndpoint}/api/v4/roster/${selected_user.IdUser}/${IdTeamDivision}/${coaches_season[role_index].IdRoleOverride}`)
            .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
            .then(ok => {
                this.props.seasonActions && this.props.seasonActions.fetchAllCoaches(this.props.params.idSeason);
                this.props.refresh && this.props.refresh();
                this.setState({ coaches_season: [...coaches_season.slice(0, role_index), ...coaches_season.slice(role_index + 1)] });
            });
        // optimistic
        
    }
    onSearch = () => {
        this.setState({
            search_coach: this.txtSearchCoaches.value,
            search_all_teams: this.txtSearchOtherTeams.value,
        });
    }

    onSearchSQWAD = (e) => {
        const { teams } = this.state;        
        e && e.preventDefault && e.preventDefault();
        if (this.state.fetching_user) return;
        const email = this.txtSearchCoaches.value.trim();
        if (!email) return;
        // TODO: validate this email    
        this.setState({ fetching_user: true, no_users_found: false, invalid_sqwad_owner: false, error: null }, () => {
            // Call API
            request.post(`${config.apiEndpoint}/api/v4/family/members/by_email`)
                .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
                .send({ email })
                .then((data) => {
                    if (data.body.success) {

                        // Decrypt User Info
                        //data.body.users.forEach(humanize_user);
                        this.setState({
                            fetching_user: false,
                            sqwad_users: data.body.users,
                            selected_user: null,
                            no_users_found: data.body.users.length ? false : true
                        });
                    } else
                        this.setState({ fetching_user: false, no_users_found: true });

                });
        });
    }

    render() {
        const { coaches_season = [], teams = [], mode, sqwad_users = [] } = this.state, { selected_user } = this.state, { roles } = this.props;

        let uniq_coaches = _.chain(coaches_season)
            .filter(u => {
                if (this.state.search_coach)
                    return `${u.NameFirst} ${u.NameLast}`.toLowerCase().includes(this.state.search_coach.toLowerCase());
                return true;
            })
            .groupBy(u => u.IdUser)
            .values()
            .sortBy(u => u[0].NameFirst)
            .value();

        let user_teams = selected_user ? _.chain(coaches_season)
            .filter(u => u.IdUser === selected_user.IdUser).value() : [];

        let rest_teams = _.chain(teams)
            .reject(team => _.map(user_teams, t => t.IdTeamDivision).indexOf(team.IdTeamDivision) !== -1)
            .filter(u => {
                if (this.state.search_all_teams)
                    return `${u.TeamName}`.toLowerCase().includes(this.state.search_all_teams.toLowerCase());
                return true;
            })
            .value();

        let coach_roles = _.filter(roles, r => r.IdRole === 4);

        return <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }} className=" d-flex flex-row">

            {/* LIST OF COACHES REGISTERED */}
            {mode === 1 && <div className="w-100 h-100 p-3" style={{ overflowY: 'auto', borderRight: `1px solid #ccc` }}>
                <div className="d-flex flex-row">
                    <h4 className="montserrat line1 black align-self-center">Coaches registered</h4>
                    <button className="btn btn-sm btn-info font-8 align-self-center ml-auto py-1" style={{ borderRadius: 12, height: 24 }} onClick={() => this.setState({ mode: 2 })}>INVITE</button>
                </div>
                <p className="montserrat line1 black">This is the list of coaches that are already registered on the season</p>
                <hr />
                <div className="w-100 mb-3">
                    <input ref={i => this.txtSearchCoaches = i} placeholder="Search coaches" className={`form-control align-self-center ${(this.state.search_coach && this.txtSearchCoaches.value && !uniq_coaches.length) ? 'bg-danger white' : 'black'}`} onChange={this.onSearch} />
                </div>
                <ul>
                    {uniq_coaches && uniq_coaches.map(([coach], index) =>
                        <li onClick={() => this.setState({ selected_user: coach })} className={`btn m-0 btn-${(selected_user && selected_user.IdUser === coach.IdUser) ? 'success white pl-2' : 'link black'} btn-block text-left px-0 d-flex flex-row`} key={index}>
                            <div className="cover align-self-center bordered" style={{ width: 30, height: 30, borderRadius: '50%', background: `url(${coach.UserImageUrl}?full=80) no-repeat center center` }}></div>
                            <span className="align-self-center montserrat font-10 ml-2">{`${coach.NameFirst} ${coach.NameLast}`}</span>
                        </li>
                    )}
                </ul>
            </div>}

            {/* SQWAD USERS */}
            {mode === 2 && <div className="w-100 h-100 p-3" style={{ overflowY: 'auto', borderRight: `1px solid #ccc` }}>
                <div className="d-flex flex-row">
                    <h4 className="montserrat line1 black align-self-center">SQWAD Users</h4>
                    <button className="btn btn-sm btn-danger font-8 align-self-center ml-auto py-1" style={{ borderRadius: 12, height: 24 }} onClick={() => this.setState({ mode: 1 })}>CLOSE</button>
                </div>
                <p className="montserrat line1 black">Search through all the SQWAD Network for any user to add them to the Coaches pool</p>
                <hr />
                <form className="w-100 d-flex flex-row" >
                    <input ref={i => this.txtSearchCoaches = i} placeholder="Email" className={`form-control align-self-center black`} />
                    <button type="submit" onClick={this.onSearchSQWAD} className="btn btn-link"><i className={`fas ${this.state.fetching_user ? 'fa-cog fa-spin' : 'fa-search'} black`} /></button>
                </form>
                {this.state.no_users_found && <span className="red block font-8 m-1">No users found with that email!</span>}

                <ul className="mt-3">
                    {sqwad_users && sqwad_users.map((coach, index) =>
                        <li onClick={() => this.setState({ selected_user: coach })} className={`btn m-0 btn-${(selected_user && selected_user.IdUser === coach.IdUser) ? 'success white pl-2' : 'link black'} btn-block text-left px-0 d-flex flex-row`} key={index}>
                            <div className="cover align-self-center bordered" style={{ width: 30, height: 30, borderRadius: '50%', background: `url(${coach.UserImageUrl}?full=80) no-repeat center center` }}></div>
                            <span className="align-self-center montserrat font-10 ml-2">{`${coach.NameFirst} ${coach.NameLast}`}</span>
                        </li>
                    )}
                </ul>

            </div>
            }

            {/* LIST OF TEAMS ROSTERED */}
            <div className="w-100 h-100 p-3" style={{ overflowY: 'auto' }}>
                <h4 className="montserrat line1 black">Teams they coach{selected_user ? ` (${_.chain(user_teams).value().length})` : ''}</h4>
                <p className="montserrat line1 black">This is the list teams this person is rostered as a coach in this season | tournament</p>
                <hr />
                {selected_user && <section>
                    <ul>
                        {_.chain(user_teams).sortBy('Team').value().map((team, index) => <li onClick={() => this.toggleTeamRemoving(team)} key={index}
                            className={`btn btn-link black btn-block d-flex flex-row text-left px-0`}
                        >
                            <div id={`btn_remove_${team.IdTeamDivision}`} className="cover align-self-center bordered" style={{ width: 30, height: 30, borderRadius: '50%', background: `url(${team.TeamImageUrl}?full=80) no-repeat center center` }} />
                            <div className="d-flex flex-column ml-2 align-self-center">
                                <span className="align-self-start montserrat font-10 ml-2 line1 font-12">{`${team.Team}`}</span>
                                <span className="align-self-start montserrat font-10 ml-2 line1 font-8">{`${team.DivisionName}`}</span>
                                <span className="align-self-start montserrat font-10 ml-2 font-7 line1">{`${team.RoleOverride}`}</span>
                            </div>

                            <Popover placement="right" isOpen={team.removing} target={`btn_remove_${team.IdTeamDivision}`}>
                                <PopoverHeader className={`bg-info`}>Remove from team?</PopoverHeader>
                                <PopoverBody className="d-flex flex-column justify-content-center">
                                    <button onClick={() => this.doRemoveFromTeam(team)} className="btn btn-success">Yes, remove</button>
                                    <button onClick={() => this.toggleTeamRemoving({})} className="btn btn-danger">No, cancel</button>
                                </PopoverBody>
                            </Popover>
                        </li>)}
                    </ul>
                </section>}
            </div>

            {/* OTHER TEAMS */}
            <div className="w-100 h-100 p-3" style={{ overflowY: 'auto' }}>
                <h4 className="montserrat line1 black">Other teams{selected_user ? ` (${_.chain(rest_teams).value().length})` : ''}</h4>
                <p className="montserrat line1 black">{`Select teams from this list to roster${selected_user ? ` ${selected_user.NameFirst} ` : ' '}as a coach`}</p>
                <hr />
                <div className="w-100 mb-3">
                    <input ref={i => this.txtSearchOtherTeams = i} placeholder="Search other teams" className={`form-control align-self-center ${(this.state.search_all_teams && this.txtSearchOtherTeams.value && !rest_teams.length) ? 'bg-danger white' : 'black'}`} onChange={this.onSearch} />
                </div>
                {selected_user && <section>
                    <ul>
                        {_.chain(rest_teams || [])
                            .sortBy('TeamName')
                            .value().map((team, index) => <li onClick={() => this.toggleTeamAdding(team)} key={index} className={`btn btn-link btn-block black d-flex flex-row text-left px-0`}>

                                <div id={`btn_add_${team.IdTeamDivision}`} className="cover align-self-center bordered" style={{ width: 30, height: 30, borderRadius: '50%', background: `url(${team.TeamImageUrl}?full=80) no-repeat center center` }} />

                                <div className="d-flex flex-column ml-2 align-self-center">
                                    <span className="align-self-start montserrat font-10 ml-2 line1 font-12">{`${team.TeamName}`}</span>
                                    <span className="align-self-start montserrat font-10 ml-2 line1 font-8">{`${team.DivisionName}`}</span>
                                </div>

                                <Popover placement="right" isOpen={team.adding} target={`btn_add_${team.IdTeamDivision}`} toggle={() => this.toggleTeamAdding(team)}>
                                    <PopoverHeader className={team.spin ? '' : `bg-info`}>{team.spin ? 'Please wait...' : 'Select the role'}</PopoverHeader>
                                    {!team.spin && <PopoverBody className="d-flex flex-column justify-content-center">
                                        {coach_roles.map((role, index) => <button key={index} className="btn btn-link font-8 btn-sm btn-block text-left" onClick={() => {
                                            this.assignNewTeam(team, role);
                                        }}>{role.RoleName}</button>)}
                                    </PopoverBody>}
                                </Popover>
                            </li>)}
                    </ul>
                </section>}
            </div>
        </div >
    }
}

/*

<button key={i} className={`btn btn-${parseInt(item.IdRoleOverride, 10) === parseInt(role.IdRoleOverride, 10) ? 'warning' : 'link'} btn-sm btn-block d-flex flex-row`} onClick={() => this.assignRole(role)}>
                  {role.RoleName}
                </button>))}

                
<Popover placement="bottom" isOpen={this.state.deleting} target={`btn-delete-${entity.IdMembership || entity.randomId}`} toggle={this.toggleDelete}>
          <PopoverHeader>Are you sure?</PopoverHeader>
          <PopoverBody className="d-flex flex-row justify-content-center">
            <button className="btn btn-success btn-sm" onClick={this.doDelete}>Yes, Delete it</button>
            <button className="btn btn-danger btn-sm" onClick={this.toggleDelete}>No, Cancel</button>
          </PopoverBody>
        </Popover>
*/

export default BatchCoachAssign;